import { deleteTarget } from "@/app/deleteTarget";
import { EntityDrawer } from "@/app/EntityDrawer";
import { channelGroups, type Channel, type ChannelGroup, type Input } from "@/app/master";
import { channelGroupDraft, channelGroupInput } from "./channelGroupDraft";
import { ChannelGroupForm } from "./ChannelGroupForm";

interface Props {
  /** 要编辑的组；null 表示新建。 */
  row: ChannelGroup | null;
  groups?: ChannelGroup[]; channels?: Channel[];
  onClose: () => void;
  /** 删除后再做的事：详情页据此回到列表（D180）。 */
  onDeleted?: () => void;
}

/** 通道组的新建与编辑抽屉（决策 D69）：通道组合列表页与路由规则页的发送目标共用，保存即生效，刷新通道组缓存。 */
export function ChannelGroupDrawer({ row, groups, channels, onClose, onDeleted }: Props) {
  return (
    <EntityDrawer title={row ? `编辑通道组合 ${row.name}` : "新建通道组合"} initial={channelGroupDraft(row ?? undefined)} convert={(d) => channelGroupInput(d, groups, channels)}
      save={(body: Input<ChannelGroup>) => (row ? channelGroups.update(row.id, body) : channelGroups.create(body))}
      invalidate={["channel-groups"]} message={row ? "已更新通道组合，已生效" : "已新建通道组合，已生效"} deletion={row ? { ...deleteTarget("通道组合", row.name, channelGroups, row.id, ["channel-groups"]), after: onDeleted } : undefined} onClose={onClose}>
      {(f) => <ChannelGroupForm draft={f.draft} errors={f.errors} set={f.set} isNew={!row} channels={channels} groups={groups} selfId={row?.id} />}
    </EntityDrawer>
  );
}
